import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {
    getNotificationSettings,
    saveNotificationSettings,
} from "./notification.api";
import type { NotificationSettings, NotificationSettingsRequest } from "@shyne/shared/api";

interface State {
    data: NotificationSettings | null;
    loading: boolean;
    saving: boolean;
    error: string | null;
}

const initialState: State = {
    data: null,
    loading: false,
    saving: false,
    error: null,
};

export const fetchNotifications = createAsyncThunk(
    "notification/fetch",
    async () => await getNotificationSettings(),
);

export const updateNotifications = createAsyncThunk(
    "notification/update",
    async (settings: NotificationSettingsRequest) =>
        await saveNotificationSettings(settings),
);

const slice = createSlice({
    name: "notification",
    initialState,
    reducers: {},
    extraReducers: (b) => {
        b.addCase(fetchNotifications.pending, (s) => {
            s.loading = true;
            s.error = null;
        })
            .addCase(fetchNotifications.fulfilled, (s, a) => {
                s.loading = false;
                s.data = a.payload;
                s.error = null;
            })
            .addCase(fetchNotifications.rejected, (s, a) => {
                s.loading = false;
                s.error = a.error.message ?? "Failed to load notification settings.";
            })
            .addCase(updateNotifications.pending, (s) => {
                s.saving = true;
                s.error = null;
            })
            .addCase(updateNotifications.fulfilled, (s, a) => {
                s.saving = false;
                s.data = a.payload;
                s.error = null;
            })
            .addCase(updateNotifications.rejected, (s, a) => {
                s.saving = false;
                s.error =
                    a.error.message ?? "Failed to update notification settings.";
            });
    },
});

export default slice.reducer;
